import React, { useRef } from 'react';
import { useEnteredView } from '@fiverr-private/hooks';
import { Container, Stack } from '@fiverr-private/layout_components';
import { List, ListItem, ListItemIcon } from '@fiverr-private/list';
import { Image } from '@fiverr-private/media';
import { Button } from '@fiverr-private/button';
import { Text } from '@fiverr-private/typography';
import { Domingo } from '@fiverr-private/domingo';
import { getContext } from '@fiverr-private/fiverr_context';
import { CheckIcon } from '@fiverr-private/visuals';
import { FiverrProLightLogo } from '../ui/FiverrProLightLogo';
import { Heading } from '../ui/Heading';
import { translate } from '../../../shared/helpers';
import { sendBiankaImpression } from '../../../shared/biEvents';
import { EVENT_NAMES } from '../../../shared/biEvents/eventNames';
import { sendMixpanelEvent } from '../utils/mixpanel';
import { MIXPANEL_EVENTS } from '../utils/eventNames';
import { BENEFITS_KEYS } from './constants';

import * as styles from './styles.ve.css';

const ProSection = () => {
  const container = useRef<HTMLDivElement>(null);
  const eventTrackingRef = useRef<HTMLDivElement>(null);

  const { url } = getContext();

  const proUrl = Domingo(url).removePath().pro().url;

  useEnteredView(eventTrackingRef, {
    threshold: 1,
    onEntered: () => {
      sendBiankaImpression({
        eventName: EVENT_NAMES.BIANKA.EXPERTS_CAROUSEL_IS_SHOWN,
        componentName: 'experts_carousel',
        componentText: 'ProSection',
      });
    },
  });

  // const handleClick = (descriptionHeading: string, index: number) => {
  //   sendBiankaClick({
  //     eventName: EVENT_NAMES.BIANKA.CLICKED_ON_EXPERTS_CAROUSEL,
  //     elementName: 'experts_carousel',
  //     elementType: ElementType.BUTTON,
  //     elementText: descriptionHeading,
  //     position: index + 1,
  //   });

  //   sendMixpanelEvent({
  //     eventName: EVENT_NAMES.MIXPANEL.LOHP_CLICKED_VETTED_EXPERT_CARD,
  //     clickedElement: descriptionHeading,
  //     clickedElementOrder: index + 1,
  //   });
  // };

  const handleCTAClick = () => {
    sendMixpanelEvent({
      eventName: MIXPANEL_EVENTS.CLICKED_PRO_CTA,
      clickedElement: 'Try Fiverr Pro',
      elementSource: 'ProSection',
    });
  };

  return (
    <Container ref={container}>
      <Stack
        direction={{ default: 'column', md: 'row' }}
        alignItems={{ md: 'center' }}
        className={styles.wrapperStyles}
      >
        <Stack direction="column" flex="1" order={{ default: 1, md: 2 }} gap="0">
          <Container className={styles.logoContainerStyles}>
            <FiverrProLightLogo />
          </Container>

          <Heading>{translate('v17.pro_section.heading')}</Heading>

          <List padding="0" className={styles.listStyles}>
            {BENEFITS_KEYS.map((benefit, index) => (
              <ListItem key={index}>
                <ListItemIcon>
                  <CheckIcon color="white" />
                </ListItemIcon>
                <Text color="white" className={styles.textStyles}>
                  {translate(benefit)}
                </Text>
              </ListItem>
            ))}
          </List>

          <Button
            colorScheme="white"
            size="lg"
            className={styles.buttonStyles}
            href={proUrl}
            hidden={{ default: true, md: false }}
            onClick={handleCTAClick}
          >
            {translate('v17.pro_section.cta')}
          </Button>
        </Stack>

        <Container className={styles.imageContainerStyles} order={{ default: 2, md: 1 }}>
          <Image
            src="https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/ece694f2c564ff1a7bf0d29191fcd438-1762166718596/brand-lohp-v17-pro.png"
            alt="Pro Section Image"
            height="100%"
            width="100%"
            objectFit="contain"
          />
        </Container>

        <Container order={{ default: 3, md: 2 }} hidden={{ default: false, md: true }}>
          <Button href={proUrl} colorScheme="white" size="lg" className={styles.buttonStyles} onClick={handleCTAClick}>
            {translate('v17.pro_section.cta')}
          </Button>
        </Container>
      </Stack>
    </Container>
  );
};

export default ProSection;
